/**
 * @file Defines the {@link localStorageSupported} function
 * @author Joe Thompson <joe.thompson@1x2network.com>
 * @version 1.0.23
 */

/**
 * Returns whether or not localStorage supported
 * @returns {boolean}
 */
export function localStorageSupported() {

    let foo = 'foo' //Placeholder key
    let bar = true  //Placeholder value

    //Try and store placeholder in localStorage
    try {

        localStorage.setItem(foo, bar)  //Store placeholder
        localStorage.removeItem(foo)    //Remove placeholder
        return true                     //Return localStorage supported
        
    }

    //localStorage not supported
    catch(e) {
        return false
    }

}